export default "__VITE_ASSET__CH$uKlfb__"